export const LIST = [
  {
    id: 'list-item-001',
    text: (
      <>
        1. <b>Limited Spots:</b> Spots at our premium events are strictly
        limited. Once they&#39;re full, you&#39;ve missed your chance to
        connect.
      </>
    ),
  },
  {
    id: 'list-item-002',
    text: (
      <>
        2. <b>Decision Makers Only:</b> 94% of our members are business owners
        and c-suite executives. The right people are already in the room.
      </>
    ),
  },
  {
    id: 'list-item-003',
    text: (
      <>
        3. <b>Real Results:</b> Our members already close $30M+in business with
        each other. Every round could unlock your next million-dollar
        relationship.
      </>
    ),
  },
  {
    id: 'list-item-004',
    text: (
      <>
        4. <b>Exclusive Access:</b> Access to Australia&#39;s most exclusive
        courses and top business leaders isn&#39;t available anywhere else.
      </>
    ),
  },
]
